(ns bec-cljs-common.session
  (:require [taoensso.timbre :as log]
            [reagent.core :as r]
            [re-frame.core :as rf]
            [ajax.core :as ajax :refer [json-request-format json-response-format]]
            [clojure.core.async :as async]
            [bec-cljs-common.config :as config]
            [bec-cljs-common.worker :as bcc.worker]
            [bec-cljs-common.re-frame :as bcc.rf]
            [bec-cljs-common.state-sync-client :as bcc.ssc]))


(defn path [& args]
  (apply conj [:bec-clj-common :session] args))


;; NOTE: Don't make this thing "simpler" or "nicer"; I know it needs a wrapper etc.. It's here because I want to work on debouncing and this is one of the simplest but still somewhat interesting things to do this on. -- lnostdal
(let [ch (async/chan (async/sliding-buffer 1))]
  (bcc.worker/go-task-handler! ch)
  (rf/reg-event-fx ::add-minutes
    (fn [{:keys [db]} [_ minutes]]
      (println "::add-minutes" minutes) ;; So we can see the debouncing happening.
      (async/put! ch (bcc.worker/with-result-ch
                       (fn [result-ch]
                         (rf/dispatch [::bcc.rf/xhrio {:method :put, :event-key ::add-minutes
                                                       :uri (str config/app-server-url "/session/add-minutes/" minutes)
                                                       :format (json-request-format)
                                                       :response-format (json-response-format {:keywords? true})
                                                       :result-ch result-ch}]))))
      ;; TODO: This is terrible. I think each component that needs debouncing needs its own ratom to separate server and client state from each other. It should be done in a completely transparent and automated way tho -- i.e. probably generated by reusing the path-name used for the server data as an identifier.
      #_{:db (assoc-in db (path :remaining-seconds) (* remaining-minutes 60))}
      {:db db})))


;; TODO: Not sure why this needs to be a rf-event anymore. It probably doesn't and shouldn't.
(rf/reg-event-fx ::set-players-allowed
  (fn [{:keys [db]} [_ player-amount]]
    (-> (assoc-in db (path :players-allowed) player-amount)
        (bcc.ssc/patch! db))))
